export const isProd = () => {
    return window._env_.REACT_APP_STAGE && window._env_.REACT_APP_STAGE === "production"
};

export const APIGATEWAY =
    {
        URL: window._env_.REACT_APP_APIMANAGER,
        AUTH: "ECCO_IND_AUTH",
        APIKEY: window._env_.REACT_APP_APIMANAGER_ECCO_IND_KEY
    };

export const RESTBLOG =
    {
        URL: window._env_.REACT_APP_RESTAPI_WORDPRESS,
        AUTH: null
    };

export const PUBLICURL = window._env_.PUBLIC_URL;

export const RECAPTCHA = {
    PUBLICKEY: window._env_.REACT_APP_RECAPTCHA_SITEKEY,
    APIMANAGERKEY: window._env_.REACT_APP_APIMANAGER_RECAPTCHA_KEY,
    APIMANAGERUSER: window._env_.REACT_APP_APIMANAGER_RECAPTCHA_USER,
    APIMANAGERPASS: window._env_.REACT_APP_APIMANAGER_RECAPTCHA_PASS
};

export const GOOGLEMAPS = {
    APIKEY: window._env_.REACT_APP_GOOGLE_MAPS_KEY,
    CLIENTID: window._env_.REACT_APP_GOOGLE_MAPS_CLIENT_ID
};

export const STATICPAGES = window._env_.REACT_APP_STATICPAGES;

export const ASSETS_S3 = window._env_.REACT_APP_ASSETS;

export const INACTIVITY_TIMEOUT = {
    PANEL: window._env_.REACT_APP_PANEL_INACTIVITY_LOGOUT,
    REGISTRATION: window._env_.REACT_APP_REGISTRATION_INACTIVITY_GOLOGIN,
    DEFAULT_EVENTS: [
        "keydown",
        "mousedown",
        "touchstart",
        "MSPointerDown",
        "visibilitychange"
    ]
};

export const GOOGLE_TAGMANAGER = {
    ID: window._env_.REACT_APP_GOOGLE_TAGMANAGER_ID,
    AUTH: window._env_.REACT_APP_GOOGLE_TAGMANAGER_AUTH,
    PREVIEW_ENV: window._env_.REACT_APP_GOOGLE_TAGMANAGER_PREVIEWENV
};